function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* global File */
import { Button, ButtonGroup, Modal } from '@applyboard/ui-components';
import { useEventTracker, useCurrentUser } from '@applyboard/ui-utils';
import React, { useCallback, useEffect, useState } from 'react';
import { usePapaParse } from 'react-papaparse';
import { ConfirmationModal } from "./components/ConfirmationModal";
import { CsvImportView } from "./components/CsvImportView";
import { getReferralSourceText, getRpLabel, isFileValid } from "./components/CsvImportView/utils";
import { CONSENT_REQUIRED, CUSTOM_REFERRAL_CHAR_LIMIT, FEATURE_TITLE, FILE_REQUIRED, FILE_TOO_LARGE, IMPORTING_LABEL, MAX_CUSTOM_REFERRAL_MSG_LENGTH, MAX_FILE_SIZE, MAX_STUDENTS, MISSING_CUSTOM_REFERRAL, onMouseDown, PARSE_LABEL, RP_REQUIRED, SUSPENDED_RP_DIALOG_TITLE, SUSPENDED_RP_DIALOG_NOTICE_MESSAGE, SUSPENDED_RP_DIALOG_INSTRUCTION } from "./consts";
import { useImportStudents } from "./data/import";
import { useStaffInformation } from "../../data";
import { SuspendedRPDialog } from "../Rp/SuspendedRPDialog/SuspendedRPDialog";
import { getUserAgentInformation } from "../../util";
export var BulkImportModal = function BulkImportModal(_ref) {
  var _currentUser$included, _currentUser$included2;
  var open = _ref.open,
    setShowModal = _ref.setShowModal,
    isAdmin = _ref.isAdmin;
  var _usePapaParse = usePapaParse(),
    readString = _usePapaParse.readString;
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    currentUser = _useCurrentUser2[0];
  var currentUserAgentInformation = getUserAgentInformation(currentUser);
  var currentUserAgentInformationAttributes = currentUserAgentInformation === null || currentUserAgentInformation === void 0 ? void 0 : currentUserAgentInformation.attributes;
  var isRpSuspended = currentUserAgentInformationAttributes === null || currentUserAgentInformationAttributes === void 0 ? void 0 : currentUserAgentInformationAttributes.suspended;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    initialLoad = _useState2[0],
    setInitialLoad = _useState2[1];

  // form fields
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    rp = _useState4[0],
    setRp = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    referralSource = _useState6[0],
    setReferralSource = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    customReferralSource = _useState8[0],
    setCustomReferralSource = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    customReferralErrorMessage = _useState10[0],
    setCustomReferralErrorMessage = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedFile = _useState12[0],
    setSelectedFile = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    informedConsentGiven = _useState14[0],
    setInformedConsentGiven = _useState14[1];

  // form states
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    importDetails = _useState16[0],
    setImportDetails = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isImportRunning = _useState18[0],
    setIsImportRunning = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    validationErrorsVisible = _useState20[0],
    setValidationErrorsVisible = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    hasConfirmed = _useState22[0],
    setHasConfirmed = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isConfirmationModalOpen = _useState24[0],
    setIsConfirmationModalOpen = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    studentLimitReached = _useState26[0],
    setStudentLimitReached = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    formErrors = _useState28[0],
    setFormErrors = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    serverErrors = _useState30[0],
    setServerErrors = _useState30[1];
  var _useState31 = useState(''),
    _useState32 = _slicedToArray(_useState31, 2),
    fileError = _useState32[0],
    setFileError = _useState32[1];
  var isOwner = !(currentUser !== null && currentUser !== void 0 && (_currentUser$included = currentUser.included) !== null && _currentUser$included !== void 0 && (_currentUser$included = _currentUser$included[0]) !== null && _currentUser$included !== void 0 && _currentUser$included.attributes.agency_staff);
  var canAssignStaff = isAdmin || isOwner;

  // hooks
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useStaffInformation = useStaffInformation(currentUser === null || currentUser === void 0 || (_currentUser$included2 = currentUser.included) === null || _currentUser$included2 === void 0 || (_currentUser$included2 = _currentUser$included2[0]) === null || _currentUser$included2 === void 0 ? void 0 : _currentUser$included2.id, !isAdmin),
    staffData = _useStaffInformation.staffData;
  var _useImportStudents = useImportStudents(),
    importStudents = _useImportStudents.importStudents;

  // import
  var trackImportStudents = useCallback(function (data, duration) {
    var successes = data.successes,
      errors = data.errors;
    var numberOfErrors = 0;
    if (errors && errors.size > 0) {
      Array.from(errors.entries()).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          value = _ref3[1];
        numberOfErrors += value.length;
        return null;
      });
    }
    trackEvent({
      event: 'Bulk Import - Clicked Import Students',
      group: 'Bulk Import',
      data: {
        duration: duration,
        successes: successes,
        errors: numberOfErrors
      }
    });
  }, [trackEvent]);
  var customLeadSourceValidation = useCallback(function () {
    if ((referralSource === null || referralSource === void 0 ? void 0 : referralSource.name) === 'other') {
      if (!customReferralSource.trim()) {
        return setCustomReferralErrorMessage(MISSING_CUSTOM_REFERRAL);
      }
      // Used same characters limit from AddNewStudent modal
      if (customReferralSource.length > MAX_CUSTOM_REFERRAL_MSG_LENGTH) {
        return setCustomReferralErrorMessage(CUSTOM_REFERRAL_CHAR_LIMIT);
      }
    }
    return setCustomReferralErrorMessage('');
  }, [customReferralSource, referralSource === null || referralSource === void 0 ? void 0 : referralSource.name]);
  var importStudentsWrapper = useCallback(function () {
    if (selectedFile && rp && informedConsentGiven && referralSource) {
      var startTime = Date.now();
      setImportDetails(undefined);
      setIsImportRunning(true);
      setValidationErrorsVisible(false);
      var params = {
        params: {
          file: selectedFile,
          rp: rp,
          referralSource: referralSource,
          customReferralSource: customReferralSource,
          consentGiven: informedConsentGiven
        },
        canAssign: canAssignStaff
      };
      importStudents(params, {
        onSuccess: function onSuccess(data) {
          setServerErrors(false);
          var duration = (Date.now() - startTime) / 1000;
          trackImportStudents(data, duration);
          setImportDetails(data);
          setIsImportRunning(false);
          setInformedConsentGiven(false);
          setHasConfirmed(false);
          if (data.successes === data.total) {
            setSelectedFile(undefined);
            setInitialLoad(true);
          }
          if (data.successes > 0) {
            trackEvent({
              event: 'Bulk Student Import - Bulk Added Student(s)',
              group: 'RPJ Adoption Metrics'
            });
          }
        },
        onError: function onError() {
          trackEvent({
            group: 'Bulk Import',
            event: 'Bulk Import - Session Timed Out'
          });
          setIsImportRunning(false);
          setInformedConsentGiven(false);
          setHasConfirmed(false);
          setSelectedFile(undefined);
          setInitialLoad(true);
          setServerErrors(true);
        }
      });
    }
  }, [canAssignStaff, customReferralSource, importStudents, informedConsentGiven, referralSource, rp, selectedFile, trackEvent, trackImportStudents]);
  var selectFiles = function selectFiles(files) {
    setStudentLimitReached(false);
    setFileError('');
    if (isFileValid(files)) {
      if (files[0].size > MAX_FILE_SIZE) {
        setFileError(FILE_TOO_LARGE);
      }
      setSelectedFile(files[0]);
      if (files[0]) {
        files[0].text().then(function (response) {
          readString(response.trim(), {
            worker: true,
            complete: function complete(results) {
              if (results.errors.length) {
                setFileError('Invalid File');
                return;
              }
              // account for header row in csv file
              if (results.data.length - 1 > MAX_STUDENTS) {
                setStudentLimitReached(true);
              }
            }
          });
        });
      }
    } else {
      setSelectedFile(undefined);
    }
  };
  var removeFile = function removeFile() {
    setSelectedFile(undefined);
    setImportDetails(undefined);
    setStudentLimitReached(false);
    setFileError('');
  };
  useEffect(function () {
    if ((staffData === null || staffData === void 0 ? void 0 : staffData.length) === 1) {
      var staff = staffData[0];
      setRp(_objectSpread(_objectSpread({}, staff), {}, {
        isOwner: false
      }));
    }
  }, [staffData]);

  // Display validation errors when any mandatory field change
  useEffect(function () {
    var errors = !selectedFile || !!fileError || !rp || !informedConsentGiven || !referralSource || referralSource.name === 'other' && !customReferralSource.trim();
    setFormErrors(errors);
    if (initialLoad) {
      setValidationErrorsVisible(false);
      return;
    }
    setValidationErrorsVisible(errors);
    if ((referralSource === null || referralSource === void 0 ? void 0 : referralSource.name) === 'other' && !customReferralSource) {
      customLeadSourceValidation();
    }
    if (errors) {
      var missingFields = [];
      var reportedErrors = [];
      if (!selectedFile) {
        missingFields.push('missing file');
        reportedErrors.push(FILE_REQUIRED);
      }
      if (!rp) {
        missingFields.push('missing rp');
        reportedErrors.push(RP_REQUIRED);
      }
      if (!informedConsentGiven) {
        missingFields.push('missing informed consent');
        reportedErrors.push(CONSENT_REQUIRED);
      }
      if (!referralSource) {
        missingFields.push('missing referral source');
        reportedErrors.push(RP_REQUIRED);
      }
      if (referralSource && !customReferralSource) {
        missingFields.push('missing custom referral');
        reportedErrors.push(customLeadSourceValidation());
      }
      trackEvent({
        event: 'Bulk Import - Missing Form Requirements',
        group: 'Bulk Import',
        data: {
          missingFields: missingFields,
          reportedErrors: reportedErrors
        }
      });
    }
  }, [selectedFile, rp, informedConsentGiven, initialLoad, referralSource, customReferralSource, fileError, trackEvent, customLeadSourceValidation]);

  // Import students when all validations pass
  useEffect(function () {
    if (!hasConfirmed) {
      return;
    }
    importStudentsWrapper();
  }, [hasConfirmed, importStudentsWrapper]);

  // Clear customReferralSouce when "Other" is not the selected option anymore
  useEffect(function () {
    if ((referralSource === null || referralSource === void 0 ? void 0 : referralSource.name) !== 'other' || referralSource === null) {
      setCustomReferralSource('');
    }
  }, [referralSource]);
  if (isRpSuspended) {
    return /*#__PURE__*/React.createElement(SuspendedRPDialog, {
      isOpen: open,
      setIsOpen: setShowModal,
      onCloseClick: setShowModal,
      title: SUSPENDED_RP_DIALOG_TITLE,
      noticeMessage: SUSPENDED_RP_DIALOG_NOTICE_MESSAGE,
      instruction: SUSPENDED_RP_DIALOG_INSTRUCTION
    });
  }
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    handleClose: function handleClose(_, reason) {
      // dont close the window on ESC or backdropClick
      if (!reason) {
        setShowModal(false);
      }
    },
    title: FEATURE_TITLE,
    footerButtons: function footerButtons() {
      return /*#__PURE__*/React.createElement(ButtonGroup, {
        position: "bottom"
      }, /*#__PURE__*/React.createElement(Button, {
        onMouseDown: onMouseDown,
        onClick: function onClick() {
          setShowModal(false);
        },
        variant: "text",
        color: "secondary"
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        onMouseDown: onMouseDown,
        onClick: function onClick() {
          setInitialLoad(false);
          if (!isImportRunning && !formErrors) {
            setIsConfirmationModalOpen(true);
          } else {
            setValidationErrorsVisible(true);
          }
        },
        variant: "contained",
        color: "primary",
        disabled: isImportRunning || validationErrorsVisible || studentLimitReached
      }, isImportRunning ? IMPORTING_LABEL : PARSE_LABEL));
    },
    id: "bulkImportModal"
  }, /*#__PURE__*/React.createElement(CsvImportView, {
    isAdmin: isAdmin,
    rp: rp,
    setRp: setRp,
    referralSource: referralSource,
    setReferralSource: setReferralSource,
    selectedFile: selectedFile,
    informedConsentGiven: informedConsentGiven,
    setInformedConsentGiven: setInformedConsentGiven,
    validationErrorsVisible: validationErrorsVisible,
    setValidationErrorsVisible: setValidationErrorsVisible,
    importDetails: importDetails,
    staffData: staffData,
    selectFiles: selectFiles,
    removeFile: removeFile,
    customReferralSource: customReferralSource,
    setCustomReferralSource: setCustomReferralSource,
    customReferralErrorMessage: customReferralErrorMessage,
    customLeadSourceValidation: customLeadSourceValidation,
    studentLimitReached: studentLimitReached,
    isImportRunning: isImportRunning,
    serverErrors: serverErrors,
    setServerErrors: setServerErrors,
    fileError: fileError
  }), /*#__PURE__*/React.createElement(ConfirmationModal, {
    open: isConfirmationModalOpen,
    setShowModal: setIsConfirmationModalOpen,
    setConfirmationGiven: setHasConfirmed
  }, "Before proceeding, please confirm you would like to", ' ', rp ? "assign these students to ".concat(getRpLabel(rp)) : 'add these students', referralSource ? " with ".concat(getReferralSourceText(referralSource)) : ' with no referral source'));
};